/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum ProductId {
  SingleInvoice = 0,
  AssetConsumption = 1,
  AssetTiered = 2,
  RegisterConsumption = 5,
  RegisterTiered = 6,
  AddOnPremiumIntegration = 110,
  AddOnForcedSSO = 1000,
  AddOnCustomSSO = 1001,
}
